@let imageResponse = getSignal('image')();
@let titleResponse = getSignal('title')();
@let descriptionResponse = getSignal('description')();
@if(showElement() === 'image') {
  @if (imageResponse.success) {
  <app-editable-image 
    [elemId]="imageResponse.payload" 
    [imageReference]="imageReference" 
    [fileTypes]="supportedFileTypes"
    [maxWidth]="1000"
    [maxHeight]="1000"
    [customClass]="'two-colum-text-image-custom-class-image custom-elevation-z2'">
  </app-editable-image>
  }
}
@else if (showElement() === 'text') {
  <div class="overlay-text">
    @if (titleResponse.success) {
    <app-editable-text [customClass]="'two-colum-text-image-custom-class-text custom-title-medium'"
      [elemId]="titleResponse.payload">
    </app-editable-text>
    }

    @if (descriptionResponse.success) {
    <app-editable-text [customClass]="'two-colum-text-image-custom-class-text custom-body-medium'"
      [elemId]="descriptionResponse.payload">
    </app-editable-text>
    }
  </div>
} @else {
  <div class="slide-content">
    @if (imageResponse.success) {
    <app-editable-image 
      [elemId]="imageResponse.payload" 
      [imageReference]="imageReference"
      [fileTypes]="supportedFileTypes" 
      [maxWidth]="1000"
      [maxHeight]="1000"
      [customClass]="'two-colum-text-image-custom-class-image custom-elevation-z2'">
    </app-editable-image>
    }

    <div class="slide-overlay-text costum-mat-secondary-container" (click)="expandText()"
      [ngClass]="{'expanded': textExpanded}">
      @let expandedClass = textExpanded ? 'expanded' : '';
      @if (titleResponse.success) {
      <app-editable-text [customClass]="'two-colum-text-image-custom-class-text-small custom-title-medium'"
        [elemId]="titleResponse.payload">
      </app-editable-text>
      }

      @if (descriptionResponse.success) {
      <app-editable-text [customClass]="'two-colum-text-image-custom-class-text-small custom-body-medium ' + expandedClass"
        [elemId]="descriptionResponse.payload">
      </app-editable-text>
      }
    </div>
  </div>
}